import React from "react";

import Paginator from "./../../Paginator/containers/PaginatorContainer";
import EpTable from "./EpTable";

function EpComponent(props) {
  const { state } = props
  return (
    <div className="content-line">
      <div className="line line-100">
        <div className="search-container">
          <div className="kml-file-input-form">
            <div className={(state.nameError && !state.name) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
              <input
                placeholder='Cantidad QRs'
                type="number"
                className="kml-input"
                value={state.cant}
                onChange={props.handlerTextPunto}
                min={0}
              />
            </div>
            <div onClick={props.onGetQrs} className={state.getqrs ? 'kml-input-form-bottons primary-background-color on-mouse-hover' : 'kml-input-form-bottons gray-background-color on-mouse-hover'}>
              <i className="fas fa-qrcode"></i>
            </div>
          </div>
        </div>
        <hr />
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px auto' }}>
          <div style={{ display: 'flex', height: '50px' }}>
            <div className={(state.searchError) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
              <input
                placeholder='Busqueda'
                className="kml-input"
                value={state.search}
                onKeyUp={props.searchKeyUp}
                onChange={props.handlerSearch}
              />
            </div>
            <div onClick={props.onGetSearch} className='kml-input-form-bottons primary-background-color on-mouse-hover'>
              <i className="fas fa-search"></i>
            </div>
            {
              state.loading &&
              <div className="flex-center">
                <i className="fas fa-spinner spin primary-color fa-2x"></i>
              </div>
            }
          </div>
        </div>
        <EpTable list={state.qrlist} onGetQr={props.onGetQr} onOpenQr={props.onOpenQr} onGetPdf={props.onGetPdf} session={props.session} />
        <Paginator
          control={state.control}
          click={props.onChangePage}
          setKey="user-update-table-key-"
        />
      </div>
    </div>
  );
}

export default EpComponent;
